import authentication from "@irati/auth"
import {has, isNull} from "lodash"

export const defaultEmployeeName = "employee"

export default (plural: boolean = true) => {
  const settings = authentication.userTenant().settings
  const employeeName = has(settings, "employeeName") && !isNull(settings.employeeName)
    ? settings.employeeName
    : defaultEmployeeName
  return (
    `${employeeName}${plural ? "s" : ""}`
  )
}
